export default {
  'Text': 'Text',
  'Styles': 'Styles',
  'Text here': 'Text here',
  'Add subtitles': 'Add subtitles',
  'Text Color': 'Text color',
  'Outline': 'Outline',
  'Background': 'Background',
  'Position': 'Position',
}